import {Component, OnInit} from '@angular/core';
import {Router, RouterOutlet} from "@angular/router";
import {BreadcrumbComponent} from "../../shared/components/breadbrumb/breadcrumb.component";
import {HeaderComponent} from "../header/header.component";
import * as events from "node:events";
import {NgClass} from "@angular/common";
import {TranslateService} from "@ngx-translate/core";
import {LocalizeRouterService} from "@gilsdav/ngx-translate-router";
import {LanguageService} from "../../shared/services/language.service";

@Component({
  selector: 'app-sidenav',
  standalone: true,
  imports: [RouterOutlet, BreadcrumbComponent, HeaderComponent, NgClass],
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.css'
})
export class SidenavComponent {
  isSidebarVisible: boolean = false;

  constructor(
    private _translateService: TranslateService,
    private _router: Router, ) {
  }

  toggleSidebar(value: boolean): void {
    setTimeout(() => {
      this.isSidebarVisible = value;
    }, 0);
  }

  goToHome(): void {
    const currentLang = this._translateService.currentLang;
    this._router.navigate([`/${currentLang}`]);
  }

}
